import React from 'react';

export default function Boiler10Icon({
  width = 64,
  height = 67,
  startColor = '#333300',
  midColor = '#FFFFFF',
  endColor = '#333300'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 107.77 112.5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_BoilerBody">
	<path fill="#B2B29B" d="M7.433,0.451h92.792v109.122H7.433V0.451z" />
	<path fill="#DEDED4" d="M9.797,42.23h88.175v64.977H9.797V42.23z" />
	<path fill="#DEDED4" d="M9.797,2.815h88.175v37.162H9.797V2.815z" />
	<path fill="none" d="M97.973,42.23v64.977H9.797" />
	<path fill="none" d="M9.797,107.207V42.23h88.175" />
	<path fill="#333300" d="M9.797,43.469h1.126v1.126H9.797V43.469z" />
	<path fill="#333300" d="M9.797,72.41h1.126v1.238H9.797V72.41z" />
	<path fill="#333300" d="M96.733,43.469h1.239v1.126h-1.239V43.469z" />
	<path fill="#333300" d="M96.733,72.41h1.239v1.238h-1.239V72.41z" />
	<path fill="#333300" d="M9.797,3.942h1.126v1.239H9.797V3.942z" />
	<path fill="#333300" d="M9.797,37.613h1.126v1.126H9.797V37.613z" />
	<path fill="#333300" d="M9.797,20.271h1.126v1.126H9.797V20.271z" />
	<path fill="#333300" d="M96.733,3.942h1.239v1.239h-1.239V3.942z" />
	<path fill="#333300" d="M96.733,37.613h1.239v1.126h-1.239V37.613z" />
	<path fill="#333300" d="M96.733,20.271h1.239v1.126h-1.239V20.271z" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.5" d="M97.973,42.23v64.977H9.797" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.5" d="M9.797,39.978h88.175V2.815" />
	<path fill="none" stroke="#FFFFFF" strokeWidth="0.5003" d="M98.276,2.815H9.797v37.419" />
	<path fill="none" stroke="#FFFFFF" strokeWidth="0.5" d="M9.797,107.438V42.23h88.416" />
	<path fill="none" d="M9.797,39.978h88.175V2.815" />
	<path fill="none" d="M97.973,2.815H9.797v37.162" />
</g>
<g id="Group_BaseBody">
	<path fill="#333300" d="M7.433,109.572h92.792v2.364H7.433V109.572z" />
</g>
<g id="Group_PressureGauge">
	<circle fill="#99997A" cx="19.031" cy="32.996" r="4.617" />
	<circle fill="#FFFFFF" cx="19.031" cy="32.996" r="3.491" />
	<path fill="none" stroke="#FF0000" strokeWidth="0.25" d="M19.031,32.996l-2.252-1.126" />
</g>
<g id="Group_Grate">
	<path fill="#D4D4C7" d="M8.559,93.355h90.54v17.342H8.559V93.355z" />
	<path fill="#333300" d="M13.176,96.847h4.617v1.126h-4.617V96.847z" />
	<path fill="#333300" d="M20.158,96.847h4.617v1.126h-4.617V96.847z" />
	<path fill="#333300" d="M27.14,96.847h4.617v1.126H27.14V96.847z" />
	<path fill="#333300" d="M34.122,96.847h4.617v1.126h-4.617V96.847z" />
	<path fill="#333300" d="M41.104,96.847h4.617v1.126h-4.617V96.847z" />
	<path fill="#333300" d="M47.973,96.847h4.729v1.126h-4.729V96.847z" />
	<path fill="#333300" d="M54.955,96.847h4.617v1.126h-4.617V96.847z" />
	<path fill="#333300" d="M61.937,96.847h4.617v1.126h-4.617V96.847z" />
	<path fill="#333300" d="M68.918,96.847h4.617v1.126h-4.617V96.847z" />
	<path fill="#333300" d="M75.9,96.847h4.617v1.126H75.9V96.847z" />
	<path fill="#333300" d="M82.883,96.847H87.5v1.126h-4.617V96.847z" />
	<path fill="#333300" d="M89.752,96.847h4.729v1.126h-4.729V96.847z" />
	<path fill="#333300" d="M13.176,99.099h4.617v1.126h-4.617V99.099z" />
	<path fill="#333300" d="M20.158,99.099h4.617v1.126h-4.617V99.099z" />
	<path fill="#333300" d="M27.14,99.099h4.617v1.126H27.14V99.099z" />
	<path fill="#333300" d="M34.122,99.099h4.617v1.126h-4.617V99.099z" />
	<path fill="#333300" d="M41.104,99.099h4.617v1.126h-4.617V99.099z" />
	<path fill="#333300" d="M47.973,99.099h4.729v1.126h-4.729V99.099z" />
	<path fill="#333300" d="M54.955,99.099h4.617v1.126h-4.617V99.099z" />
	<path fill="#333300" d="M61.937,99.099h4.617v1.126h-4.617V99.099z" />
	<path fill="#333300" d="M68.918,99.099h4.617v1.126h-4.617V99.099z" />
	<path fill="#333300" d="M75.9,99.099h4.617v1.126H75.9V99.099z" />
	<path fill="#333300" d="M82.883,99.099H87.5v1.126h-4.617V99.099z" />
	<path fill="#333300" d="M89.752,99.099h4.729v1.126h-4.729V99.099z" />
	<path fill="#333300" d="M13.176,101.464h4.617v1.126h-4.617V101.464z" />
	<path fill="#333300" d="M20.158,101.464h4.617v1.126h-4.617V101.464z" />
	<path fill="#333300" d="M27.14,101.464h4.617v1.126H27.14V101.464z" />
	<path fill="#333300" d="M34.122,101.464h4.617v1.126h-4.617V101.464z" />
	<path fill="#333300" d="M41.104,101.464h4.617v1.126h-4.617V101.464z" />
	<path fill="#333300" d="M47.973,101.464h4.729v1.126h-4.729V101.464z" />
	<path fill="#333300" d="M54.955,101.464h4.617v1.126h-4.617V101.464z" />
	<path fill="#333300" d="M61.937,101.464h4.617v1.126h-4.617V101.464z" />
	<path fill="#333300" d="M68.918,101.464h4.617v1.126h-4.617V101.464z" />
	<path fill="#333300" d="M75.9,101.464h4.617v1.126H75.9V101.464z" />
	<path fill="#333300" d="M82.883,101.464H87.5v1.126h-4.617V101.464z" />
	<path fill="#333300" d="M89.752,101.464h4.729v1.126h-4.729V101.464z" />
	<path fill="#333300" d="M13.176,103.716h4.617v1.239h-4.617V103.716z" />
	<path fill="#333300" d="M20.158,103.716h4.617v1.239h-4.617V103.716z" />
	<path fill="#333300" d="M27.14,103.716h4.617v1.239H27.14V103.716z" />
	<path fill="#333300" d="M75.9,103.716h4.617v1.239H75.9V103.716z" />
	<path fill="#333300" d="M82.883,103.716H87.5v1.239h-4.617V103.716z" />
	<path fill="#333300" d="M89.752,103.716h4.729v1.239h-4.729V103.716z" />
	<path fill="#333300" d="M13.176,106.081h4.617v1.126h-4.617V106.081z" />
	<path fill="#333300" d="M20.158,106.081h4.617v1.126h-4.617V106.081z" />
	<path fill="#333300" d="M82.883,106.081H87.5v1.126h-4.617V106.081z" />
	<path fill="#333300" d="M89.752,106.081h4.729v1.126h-4.729V106.081z" />
	<path fill="#333300" d="M13.176,108.445h4.617v1.127h-4.617V108.445z" />
	<path fill="#333300" d="M89.752,108.445h4.729v1.127h-4.729V108.445z" />
	<path fill="none" d="M8.559,110.697V93.355h90.54" />
	<path fill="#4C4C4C" d="M9.797,94.482h2.252v2.364H9.797V94.482z" />
	<path fill="#4C4C4C" d="M95.607,94.482h2.365v2.364h-2.365V94.482z" />
</g>
<g id="Group_ControlBox">
	<path fill="#99997A" d="M100.225,96.847h6.982v8.108h-6.982V96.847z" />
	<path fill="#99997A" d="M7.433,96.847H0.451v8.108h6.982V96.847z" />
	<path fill="#CCCCBD" d="M107.207,94.482h-6.982v2.364h6.982V94.482z" />
	<path fill="#CCCCBD" d="M0.451,94.482h6.982v2.364H0.451V94.482z" />
	<circle cx="103.715" cy="101.351" r="2.252" />
	<circle cx="3.941" cy="101.351" r="2.252" />
	<path fill="#666666" d="M104.954,100.225h-5.855v2.365h5.855V100.225z" />
	<path fill="#666666" d="M2.815,100.225h5.743v2.365H2.815V100.225z" />
	<path d="M1.689,92.117h2.252v2.365H1.689V92.117z" />
</g>
<g id="Group_Nameplate">
	<path fill="#B2B29B" d="M39.977,15.541H67.68v11.711H39.977V15.541z" />
	<path d="M41.104,16.779h25.45v9.234h-25.45V16.779z" />
	<path fill="#7F0000" d="M42.229,24.888l3.491-6.982h5.744l-1.126,2.365h10.473l1.126-2.365h2.364l-1.238,2.365h2.365l-2.365,4.617   H42.229z M54.955,19.032v-1.126h2.364v1.126H54.955z" />
</g>
    
      </g>
      <rect x="0" y="0" width="107.77" height="112.5" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
